export default __webpack_public_path__ + "static/media/About.5a2b864b.JPG";